import React, { useEffect } from 'react';

import I18n from '@wetransfer/transfer/modules/i18n';
import Illustration from '@wetransfer/transfer/component/illustration';

import './ReferralWindow.scss';
import { REFERRAL } from '@wetransfer/transfer/constant/routes';
import Analytics from '@wetransfer/transfer/modules/analytics';

interface IProps {
  onClose: () => void;
}

const ReferralWindow: React.FC<IProps> = ({ onClose }) => {
  function handleClose() {
    onClose && onClose();
  }

  function trackCTA() {
    Analytics.trackSnowplowEvent({
      category: 'upsell',
      action: 'click_upsell_button',
      label: 'upsell_referral',
      property: 'upload_page',
    });
  }

  useEffect(() => {
    Analytics.trackSnowplowEvent({
      category: 'upsell',
      action: 'show_page',
      label: 'upsell_referral',
      property: 'upload_page',
    });
  }, []);

  return (
    <div className="ReferralWindow">
      <div className="transfer__contents">
        <Illustration type="upsell-thumbsup" />
        <div className="ReferralWindow__block">
          <div className="ReferralWindow__title">
            {I18n.t('refer_friend.window.title')}
          </div>
          <div
            className="ReferralWindow__text"
            dangerouslySetInnerHTML={{
              __html: I18n.t('refer_friend.window.text'),
            }}
          />
          <a
            href={REFERRAL.route}
            className="ReferralWindow__link"
            onClick={trackCTA}
          >
            {I18n.t('refer_friend.window.link')}
          </a>
        </div>
      </div>
      <div className="transfer__footer">
        <button
          type="button"
          className="transfer__button"
          onClick={handleClose}
        >
          {I18n.t('refer_friend.window.send_another')}
        </button>
      </div>
    </div>
  );
};

export default ReferralWindow;
